export const MEDICATION_LABELS = {
  section: "MEDICATIONS",
  name: "Medicine Name",
  quantity: "Quantity",
  dosage: "Dosage",
  frequency: "Frequency",
  when: "When",
  route: "Route",
  startDate: "Start Date",
  endDate: "End Date",
  lifetime: "For Lifetime",
  prescribedBy: "Prescribed By",
  note: "Note",
} as const;
export const MEDICATION_PLACEHOLDERS = {
  name: "Select Or Search Medicine",
  quantity: "Enter Quantity",
  dosage: "Dosage Unit",
  frequency: "Select Frequency",
  when: "When",
  route: "Select Route",
  date: "Choose Date",
  prescribedBy: "Select Provider",
  note: "Type here",
} as const;
export const ADD_MEDICATION_LABEL = "Add medication";
export const MEDICATION_RECORD_NAME = "Medication";
export const SAVE_MEDICATION_LABEL = "Save";
export const MEDICATION_LIST_PAGE_SIZE = 20;
export const MEDICINE_CATALOG_PAGE_SIZE = 5;
export const PATIENT_MEDICATION_LIST_KEY = "patient-medication-list";
